import MagnifiedImageFrame from "@/components/magnifyImageFrame";
import { FEATURES_CONSTANTS } from "./constants";

const FeaturesComp = () => {
  return <MagnifiedImageFrame {...FEATURES_CONSTANTS} />;
};

export default FeaturesComp;
